// extracted by extract-css-chunks-webpack-plugin
module.exports = {"row":"row__row--2dBZh"};